module.exports = __webpack_public_path__ + "static/img/voucher-img.aa0e156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/voucher-img.png
// module id = Uy+W
// module chunks = 41